"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupTags = void 0;

var _preact = require("preact");

var _chip = _interopRequireDefault(require("../design-system-components/chip"));

var _listGroup = _interopRequireDefault(require("../design-system-components/list-group"));

var GroupTags = function GroupTags(_ref) {
  var tags = _ref.tags,
      selectedTags = _ref.selectedTags,
      onTagClick = _ref.onTagClick;

  if (tags.length === 0) {
    return null;
  }

  return (0, _preact.h)(_listGroup.default, {
    gutterBottom: true,
    spacing: "8px"
  }, tags.map(function (tagLabel) {
    return (0, _preact.h)(_chip.default, {
      key: tagLabel,
      type: "button",
      active: selectedTags.includes(tagLabel),
      className: "qa-tag-pill",
      onClick: function onClick(_) {
        return onTagClick(tagLabel);
      }
    }, tagLabel);
  }));
};

exports.GroupTags = GroupTags;